import React from "react";
var __jsx = React.createElement;
import { useCallback, useState } from 'react';
import useToggleBlockEditToolbar from '../hooks/useToggleBlockEditToolbar';
import { EditBlockToolbar } from '../tools/EditBlockToolbar';
import { EditSelectedBlockToolbar } from '../tools/EditSelectedBlockToolbar';
import { Container } from './ToggleBlockEditToolbar.style';

var useContainerRef = function useContainerRef() {
  var _useState = useState(),
      containerNode = _useState[0],
      setContainerNode = _useState[1];

  var containerRef = useCallback(function (node) {
    if (node !== null) {
      setContainerNode(node);
    }
  }, []);
  return {
    containerRef: containerRef,
    containerNode: containerNode
  };
};

var ToggleBlockEditToolbar = function ToggleBlockEditToolbar(_ref) {
  var editorState = _ref.editorState,
      updateBlockData = _ref.updateBlockData,
      removeBlock = _ref.removeBlock,
      moveBlockUpOrDown = _ref.moveBlockUpOrDown;

  var _useContainerRef = useContainerRef(),
      containerRef = _useContainerRef.containerRef,
      containerNode = _useContainerRef.containerNode;

  var _useToggleBlockEditTo = useToggleBlockEditToolbar(editorState, containerNode, updateBlockData),
      block = _useToggleBlockEditTo.block,
      isBlockSelected = _useToggleBlockEditTo.isBlockSelected,
      isVisible = _useToggleBlockEditTo.isVisible,
      buttonPosition = _useToggleBlockEditTo.buttonPosition,
      selectBlock = _useToggleBlockEditTo.selectBlock,
      unselectBlock = _useToggleBlockEditTo.unselectBlock;

  if (!isVisible || block === null) {
    return null;
  }

  var unselectAndRemoveBlock = function unselectAndRemoveBlock(blockKey) {
    unselectBlock();
    removeBlock(blockKey);
  };

  return __jsx(Container, {
    ref: containerRef,
    style: buttonPosition,
    "data-testid": "toggle-block-edit-toolbar"
  }, block !== undefined && (isBlockSelected ? __jsx(EditSelectedBlockToolbar, {
    block: block,
    unselectAndRemoveBlock: unselectAndRemoveBlock,
    updateBlockData: updateBlockData,
    contentState: editorState.getCurrentContent()
  }) : __jsx(EditBlockToolbar, {
    block: block,
    onSelectClick: selectBlock,
    moveBlockUpOrDown: moveBlockUpOrDown,
    updateBlockData: updateBlockData,
    editorState: editorState
  })));
};

export default ToggleBlockEditToolbar;